"use client";

import SubscriptionPageContent from "./page-content";
import { SubscriptionContext } from "./subscription-context";
import { ToastProvider } from "../../components/ToastNotification/toastProvider";

export default function SubscriptionPage() {
  return (
    <SubscriptionContext>
      <SubscriptionPageContent />
      <ToastProvider />
    </SubscriptionContext>
  );
}
